/** 同一時間只執行一個 task，重疊的呼叫共用同一個 promise（避免同一個延遲結算/請求被重複觸發） */
export class SingleFlight<T> {
  private pending: Promise<T> | null = null

  async run(task: () => Promise<T>): Promise<T> {
    if (this.pending === null) {
      this.pending = task().finally(() => {
        this.pending = null
      })
    }
    return this.pending
  }
}
